import { DefaultBrowserBehavior } from "amazon-chime-sdk-js";
import { ref } from "valtio";
import { state } from "../state";

export function setupDeviceLabelTrigger() {
    if (!state.meetingSession) return;
    if (!state.audioVideo) return;

    // Suppress devices
    // state.audioVideo.setDeviceLabelTrigger(() =>
    //     Promise.resolve(new MediaStream())
    // );

    // Invoke devices
    state.audioVideo.setDeviceLabelTrigger(async () => {
        const stream = await navigator.mediaDevices.getUserMedia({
            audio: true,
            video: true,
        });
        return stream;
    });
}

export async function updateDeviceLists() {
    const { audioVideo } = state;
    if (!audioVideo) {
        return;
    }

    try {
        state.audioInputDevices = ref(await audioVideo.listAudioInputDevices());
        state.videoInputDevices = ref(await audioVideo.listVideoInputDevices());
        state.audioOutputDevices = ref(
            await audioVideo.listAudioOutputDevices()
        );
    } catch (e) {
         
        console.log(e);
    }
}

export async function changeAudioInputDevice(deviceId: string) {
    if (!state.audioVideo) return;

    try {
        await state.audioVideo.startAudioInput(deviceId);
        state.selectedAudioInputDevice = deviceId;
    } catch (error) {
         
        console.error(`Error in selecting audio input device`, error);
    }
}

export async function changeAudioOutputDevice(deviceId: string) {
    if (!state.audioVideo) return;

    const d = new DefaultBrowserBehavior();
     
    if (d.supportsSetSinkId()) {
        try {
            await state.audioVideo.chooseAudioOutput(deviceId);
            state.selectedAudioOutputDevice = deviceId;
        } catch (error) {
             
            console.error("Failed to choose audio output device.", error);
        }
    }
}

export function changeVideoInputDevice(deviceId: string) {
    if (!state.audioVideo) return;

    try {
        // await state.meetingSession?.audioVideo.chooseVideoInputDevice(deviceId);
        state.selectedVideoInputDevice = deviceId;
    } catch (error) {
         
        console.error("Failed to choose video output device.", error);
    }
}

export async function listAndSelectDevices() {
    await updateDeviceLists();

    const hasAudioInput =
        state.audioInputDevices?.some((value) => value.label) || false;
    const hasAudioOutput =
        state.audioOutputDevices?.some((value) => value.label) || false;
    const hasVideoInput =
        state.videoInputDevices?.some((value) => value.label) || false;

    if (hasAudioInput) {
        await changeAudioInputDevice(state.audioInputDevices[0].deviceId);
    }

    if (hasAudioOutput) {
        await changeAudioOutputDevice(state.audioOutputDevices[0].deviceId);
    }
    if (hasVideoInput) {
        changeVideoInputDevice(state.videoInputDevices[0].deviceId);
    }
}
